export const gameOver = {
    correctGuess: false,
    isGameOver: false
}